import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_viewvisitor } from "../shared/data.service";

import { wsVPPAdminVisitorPrintDataParm } from "../shared/wsVPPAdminVisitorPrintDataParm";
import { wsVPPAdminVisitorPrintDataInfo } from "../shared/wsVPPAdminVisitorPrintDataInfo";
import { wsVisitorStatusInfo } from "../shared/wsVPPAdminVisitorPrintDataInfo";
import { wsVisitorDateRangeInfo } from "../shared/wsVPPAdminVisitorPrintDataInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./printvisitor.component.html",
	styleUrls: ["./printvisitor.component.css"],
	providers: [ConfirmationService],
})
export class PrintVisitorComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_viewvisitor,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public UserID: number;
	public Visitor_PersonID: number;
	public FacilityID: number;
	public DateRangeID: number;
	public StartDate: Date = new Date();
	public EndDate: Date = new Date();

	public VisitorPrintData: wsVPPAdminVisitorPrintDataInfo;

	//	LogStatus Selector
	public lstStatusItems: wsVisitorStatusInfo[] = [];
	public SelectedStatus: wsVisitorStatusInfo;

	public lstDateRangeItems: wsVisitorDateRangeInfo[] = [];

	//	SortBy Selector
	public lstSortBy: any = [];
	public SelectedSortBy: any;
	public isASC: boolean;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.UserID = this.dialogConfig.data.UserID;
		this.Visitor_PersonID = this.dialogConfig.data.Visitor_PersonID;
		this.FacilityID = this.dialogConfig.data.FacilityID;
		this.DateRangeID = this.dialogConfig.data.DateRangeID;
		this.StartDate = this.dialogConfig.data.StartDate;
		this.EndDate = this.dialogConfig.data.EndDate;

		//
		//	Set lstSortBy Selector
		//
		this.lstSortBy = [
			{
				SortByID: 1,
				SortByCD: "LogDT",
				SortByDesc: "Log Date (Default)",
			},
			{
				SortByID: 2,
				SortByCD: "EntryFacilityLocation",
				SortByDesc: "Entry Location",
			},
			{
				SortByID: 3,
				SortByCD: "DestinationFacilityLocation",
				SortByDesc: "Destination Location",
			},
			{
				SortByID: 4,
				SortByCD: "ScanStation",
				SortByDesc: "Visitor Station",
			},
			{ SortByID: 5, SortByCD: "FacilityName", SortByDesc: "Facility" },
			{
				SortByID: 6,
				SortByCD: "VisitorLogStatus",
				SortByDesc: "Log Status",
			},
		];

		this.SelectedSortBy = this.lstSortBy[0];

		//
		//	Get Load Data
		//
		let parms: wsVPPAdminVisitorPrintDataParm = {
			StartDateCustom: this.StartDate,
			EndDateCustom: this.EndDate,
		};

		this.isBusy = true;
		this.dataService.VPPAdminVisitorPrintDataGet(parms).subscribe((data) => this.VPPAdminVisitorPrintDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	VPPAdminVisitorPrintDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	VPPAdminVisitorPrintDataGet_Complete(data: any) {
		this.VisitorPrintData = data;

		this.lstStatusItems = this.VisitorPrintData.StatusItems;
		this.lstDateRangeItems = this.VisitorPrintData.DateRangeItems;

		//
		//	Default Select Status
		//
		this.lstStatusItems.unshift({
			VisitorLogStatusID: 0,
			VisitorLogStatusDesc: "- ALL -",
		});

		this.SelectedStatus = this.lstStatusItems[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSortByChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSortByChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		var StartDateWork: Date;
		var EndDateWork: Date;

		if (this.SelectedStatus.VisitorLogStatusID == 5) {
			// Custom
			StartDateWork = this.StartDate;
			EndDateWork = this.EndDate;
		} else {
			this.lstDateRangeItems.forEach((item) => {
				if (this.DateRangeID == item.DateRangeID) {
					StartDateWork = item.StartDate;
					EndDateWork = item.EndDate;
				}
			});
		}

		this.isASC = true; // Only Do Ascending For Now

		var result = this.dataService.Print_RPTVisitorLog(
			this.Visitor_PersonID,
			this.SelectedStatus.VisitorLogStatusID,
			StartDateWork,
			EndDateWork,
			this.FacilityID,
			this.SelectedSortBy.SortByCD,
			this.isASC,
			this.UserID
		);

		//
		//	Generate PDF
		//
		this.isBusy = true;
		result.subscribe(
			(response: any) => {
				this.isBusy = false;

				if (response == "No Data available") {
					this.ErrorMessage = response;
				} else {
					window.open(response);

					//
					// 0 = CANCEL; 1 = SAVE
					//
					this.ref.close(1);
				}
			},
			(error) => {
				this.isBusy = false;
			}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
